import create from 'zustand';
import { persist } from 'zustand/middleware';
import Api from "services2/Api";
import { InteractionContext, baseUserInteraction } from 'utilities/logInteraction';


export type ImpersonateList = {
  userId: number;
  clientId: number;
  userName: string;
  clientName: string;
};

export type FeUser = {
  userId: number;
  name: string;
  email: string;
  clientId: number;
  clientName: string;
  feUserId: string;
};

export type ImpersonateUser = {
  userId: number;
  name: string;
  email: string;
  clientId: number;
  clientName: string;
  feUserId: string;
  licences: string[];
};

export const useFeUserStore = create(
  persist(
    (set) => ({
      userLoaded: false,
      feUser: { userId: 0, name: '', clientName: '', email: '', clientId: 0, feUserId: '' },
      impersonateUser: { userId: 0, name: '', clientName: '', email: '', clientId: 0, feUserId: '', licences: [] },
      impersonateList: [],
      impersonateUserOptions: [],
      getFeUserDetails: async (feUserId: string) => {
        try {

          const response = await Api.fetchSimple(`/api/user/feuser-details/${feUserId}`);
          const contentType = response.headers.get('content-type') || '';

          //Needs to check if response.data returns valid model before returning
          if (!contentType.includes('application/json')) {
            set({ userLoaded: false });
            console.error('Error fetching fe user details');
            return false;
          }
          else {
            const data = await response.json();

            set({ userLoaded: true });
            set({ feUser: data });
            return true;
          }
        } catch (error) {
          set({ userLoaded: false });
          console.error('Error fetching fe user details:', error);
          return false;
        }
      },
      getChangePassword: async (feUserId: string) => {
        try {
          const response = await Api.fetchSimple(`/api/user/feuser-changePass/${feUserId}`);
          const data = await response.json();

          return Boolean(data);
        } catch (error) {
          console.error('Error fetching fe user details:', error);
          return false;
        }
      },
      getImpersonateUser: async (feUserId: number) => {
        try {
          const response = await Api.fetchSimple(`/api/impersonate/start/${feUserId}`);
          const data = await response.json();

          set({ impersonateUser: data });
          return '';
        } catch (error) {
          console.error('Error fetching fe user details:', error);
          return '';
        }
      },
      stopImpersonateUser: async () => {
        try {
          await Api.fetchSimple(`/api/impersonate/stop`);
          set({ impersonateUser: { userId: 0, name: '', clientName: '', email: '', clientId: 0, feUserId: '', licences: [] } });
        } catch (error) {
          console.error('Error fetching fe user details:', error);
        }
      },
      getUserList: async () => {
        try {
          const response = await Api.fetchSimple(`/api/impersonate/list`);
          const data = await response.json();

          let sortedList = data.sort((a: { clientName: string, userName: string }, b: { clientName: string, userName: string }) => {
            if (a.clientName < b.clientName) return -1;
            if (a.clientName > b.clientName) return 1;
            if (a.userName < b.userName) return -1;
            if (a.userName > b.userName) return 1;
            return 0;
          });
          set({ impersonateList: sortedList });
        } catch (error) {
          console.error('Error fetching fe user details:', error);
        }
      },
      logPasswordChange: async (userName: string) => {
        const interaction: InteractionContext = {
          ...baseUserInteraction,
          identity: userName,
          module: "Account",
          action: "Reset Password"
        }

        try {
          await Api.post("/api/system/interaction", interaction);
        } catch (error) {
          console.error('Error logging password change:', error);
        }
      },
      logLogin: async (userName: string) => {

        const interaction: InteractionContext = {
          ...baseUserInteraction,
          identity: userName,
          module: "Account",
          action: "Login",
          context: []
        }
        try {
          await Api.post("/api/system/interaction", interaction);
        } catch (error) {
          console.error('Error logging login:', error);
        }
      },
    }),
    {
      name: 'fe-user-store', // unique name
      getStorage: () => localStorage, // use localStorage for persistence
    }
  )
);
